import Api from "./api";



export default new class ReportService extends Api {
    prefix = "report";

    get_by_id(id) {
        return this.api('get', "/" + id);
    }

    main_report(file_id, report_id) {
        return this.api('post', '/assignmain', { data: { file_id, report_id } })
    };

    sub_report(file_id, report_id) {
        return this.api('post', '/assignsub', { data: { file_id, report_id } })
    };

    remove_file_from_report(file_id, report_id) {
        return this.api('post', '/unassign', { data: { file_id, report_id } })
    };

    get_test_template(id) {
        return this.api('get', '/generatetest/' + id);
    };

    clone_report(body) {
        return this.api('post', "/clone", { data: body });
    };

    download_files(progress_callback, id) {
        return this.api('get', '/downloadfiles/' + id, {
            maxBodyLength: Infinity, responseType: 'blob', onDownloadProgress: progress_callback,
            maxContentLength: Infinity, headers: { Accept: "application/octet-stream" }
        });
    };
};